import { fixedNumber, getSettings } from "@/utils/utils";
import { normalizeSelections, isSingleFieldSelection } from "@/utils/selection";

export default {
  data(): any {
    return {};
  },

  methods: {
    handleCalculateWiningTax(totalWin) {
      const constBet = getSettings().taxWinnings;
      return fixedNumber(constBet * totalWin);
    },

    handleCalculatePossibleWinnings(totalWin) {
      const constBet = getSettings().taxWinnings;
      return fixedNumber(totalWin - constBet * totalWin);
    },

    handleCaluateMinAmount(minValue, defaultValue) {
      return minValue || defaultValue;
    },

    handleCalculateDefaultAmount(minValue, defaultValue) {
      return minValue > defaultValue ? minValue : defaultValue;
    },

    mapRaceMarketItem({ type, name, selections = [], bet_closed, suspended, closed, sort_order }: any) {
      return {
        id: `${name}`,
        name: `${name}`,
        type,
        selections,
        bet_closed,
        suspended,
        closed,
        sort_order,
      };
    },

    buildSimpleMarkets(markets: any[] = [], excludedSlugs: Set<string> = new Set()) {
      const safeMarkets = markets ?? [];
      let mergedWinPlace = false;

      return safeMarkets
        .map((m: string) => {
          const normalizedSlug = m.replace(/_/g, '-');
          if (excludedSlugs.has(m) || excludedSlugs.has(normalizedSlug)) return null;
          if ((m === 'place' || m === 'win') && !mergedWinPlace) {
            mergedWinPlace = true;
            return { id: m, name: 'fixed win/place' };
          }
          if (m === 'win_or_ew') return { id: m, name: 'win or E/W' };
          return { id: m, name: m };
        })
        .filter((market): market is { id: string; name: string } => Boolean(market))
        .filter((market) => market.id !== 'win' && market.id !== 'place');
    },

    prioritizeMarkets(markets: any[] = []) {
      const priority = markets.find((m) => m.name === 'fixed win/place')
        || markets.find((m) => m.name === 'Win or E/W')
        || null;

      return priority
        ? [priority, ...markets.filter((m) => m !== priority)]
        : markets;
    },

    sortBySortOrder(items: any[] = []) {
      return [...items].sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
    },

    handleCollectMarkets(markets: any[] = [], raceMarkets: any[] = []) {
      const safeRaceMarkets = raceMarkets ?? [];
      const fromRaceMarkets = safeRaceMarkets.map((market) => this.mapRaceMarketItem(market));
      const fromMarkets = this.buildSimpleMarkets(markets);
      return this.prioritizeMarkets([...fromRaceMarkets, ...fromMarkets]);
    },

    handleCollectMarketGroups(markets: any[] = [], marketGroups: any[] = []) {
      const safeMarketGroups = marketGroups ?? [];
      const simpleMarkets = this.buildSimpleMarkets(markets);

      const groups = this.sortBySortOrder(safeMarketGroups).map((group) => ({
        id: group.slug,
        name: group.name,
        children: this.sortBySortOrder(group.markets ?? []).map((market) => this.mapRaceMarketItem(market)),
      }));

      const childMarkets = groups.flatMap((group) => group.children);
      const mergedMarkets = this.prioritizeMarkets([...simpleMarkets, ...childMarkets]);

      return { groups, markets: mergedMarkets };
    },

    isSingleFieldSelections(selections) {
      return selections.length > 0
        && selections.every((selection) => isSingleFieldSelection(selection));
    },

    prepareMarketSelections(selections, fields, market) {
      return normalizeSelections(selections, fields, market);
    },

    flattenSelectionFields(selections) {
      return selections.map((selection) => ({
        ...selection.fields[0],
        win_odd: selection.price,
        selection,
      }));
    },
  },
};
